<template>
    <div>
        <div class="content-header text-center">
            <h2>Email Append Lookup</h2>
        </div>
        <div class="my-5" v-if="this.rangeSelected.exists == 'yes'">
            <p class="lead">WARNING: It seems as though you have already appended email addresses to the selected range. Running the email append will still result in reduction of credits per email lookup.</p>
            <p class="lead">This is the appended file matching the current selection:</p>
            <a :href="'/user_dataset?dataset=email_list-'+rangeSelected.start+'-'+rangeSelected.end+'_'+emailAppendFile+'.csv&amp;format=raw&amp;objid=null'" class="btn btn-lg btn-primary">email_list-{{this.rangeSelected.start}}-{{this.rangeSelected.end}}_{{this.emailAppendFile}}.csv</a>
        </div>
        <div class="container-fluid min-content-height">
        <form class="container-fluid" v-on:submit.prevent="lookupEmailAddress">
            <div class="row">
                <div class="col">
                    <div class="error lead" v-if="v$.form.$invalid">Please select a range to continue</div>
                    <div :class="{ error: v$.form.selectedvalue.$errors.length }">
                        <select class="form-select form-select-lg mb-3 iconenhance" @change="selectRange()" v-model="v$.form.selectedvalue.$model">
                            <option v-for='(option,index) in range' v-bind:key="id" :value="option">{{option.start}} - {{option.end}} <span class="text-right" v-if="option.exists == 'yes'">- processed &#xf14a;</span></option>
                        </select>
                        <div class="input-errors" v-for="error of v$.form.selectedvalue.$errors" :key="error.$uid">
                            <div class="error-msg">{{ error.$message }}</div>
                        </div>
                    </div>    
                </div>
                <div class="col">
                    <select class="form-select form-select-lg mb-3 d-none">
                        <option>Append to Original Data</option>
                        <option>Append to Simplified List</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <button type="submit" class="btn btn-lg btn-primary" :disabled="v$.form.$invalid">Look Up Email Addresses</button>
                </div>
            </div>
        </form>
        <div class="container-fluid min-content-height">
            <div class="row">
                <div class="col">  
                    <table>  
                      <thead>
                        <tr scope="row">
                          <th class="col">
                            <h4>First Name</h4>
                          </th>
                          <th class="col">
                            <h4>Last Name</h4>
                          </th>
                          <th class="col">
                            <h4>Address</h4>
                          </th>
                          <th class="col">
                            <h4>City</h4>
                          </th>
                          <th class="col">
                            <h4>State</h4>
                          </th>
                          <th class="col">
                            <h4>Zip</h4>
                          </th>
                          <th class="col"><h4>Email</h4></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for='person in activeEmailAppend' v-bind:key="person">
                          <td class="col">{{person.FirstName}}</td>
                          <td class="col">{{person.LastName}}</td>
                          <td class="col">{{person.Address}}</td>
                          <td class="col">{{person.City}}</td>
                          <td class="col">{{person.State}}</td>
                          <td class="col">{{person.Zip.toString().padStart(5, "0")}}</td>
                          <td class="col">{{person.Email}}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div ref="download_append_list" id="download_append_list"></div>
                </div>
                            
            </div>
        </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
import useVuelidate from '@vuelidate/core'
import { required } from '@vuelidate/validators'
export default {
    name: 'EmailAppend',
    props: {
        emailAppendFile: '',
        userSubscription: [],
        emaillistsend: [],
        passedData: [{
            type: String,
            default() {
                return 'Dataset'
            }
        }]
    }, 
    setup () {
        return {
            v$: useVuelidate()
        }
    },
    data() {
        return {
            activeEmailAppend: [],
            rangeSelected: {id: 1, start: 1, end: 100, exists: 'no'},
            range: [],
            form: {
                selectedvalue: []
            }
        }    
    },
    validations () {
        return {
            form: {
                selectedvalue: { required }
            }
        }
    },
    methods: {
        selectRange() {
            this.rangeSelected = this.form.selectedvalue;
            console.log('range selected: '+JSON.stringify(this.rangeSelected));
            this.activeEmailAppend = this.passedData.slice(this.rangeSelected.start-1, this.rangeSelected.end);
        },
        selectInitialRange(thevalue) {
            this.rangeSelected = thevalue;
            console.log('range selected: '+JSON.stringify(this.rangeSelected));
            this.activeEmailAppend = this.passedData.slice(this.rangeSelected.start-1, this.rangeSelected.end);
        },
        countReturnedEmails(returneddata) {
            var finalcount = 1;
            for(var j = 0; j < returneddata.length; j++) {
                for (var key in returneddata[j]) {
                    if(key == 'Email' && returneddata[j]['Email'] != "") {
                        finalcount++;
                    }
                } 
            };
            return finalcount;
        },
        checkRangeFile(file) {
            if(this.emaillistsend.includes(file)) {
                return 'yes';
            } else {
                return 'no';
            }
        },
        appendFinalData(originaldata,updateddata) {
            for(var j = 0; j < originaldata.length; j++){
                console.log('Append function test: '+JSON.stringify(originaldata[j]));
                if(originaldata[j]["Address"] !== "" || updateddata[j]["Email"] !== undefined || typeof updateddata[j]["Email"] !== "undefined" || typeof updateddata[j]["Email"] !== null) {
                    originaldata[j].Email = updateddata[j].Email;
                }   
            };
            return originaldata;
        },
        conformRange(passed) {
            this.rangeSelected = this.form.selectedvalue;
            return passed.slice(this.rangeSelected.start-1, this.rangeSelected.end);

        },
        transformData() {
            var number = this.passedData.length;
            var initialoptions = new Array(Math.floor(number / 100)).fill(100).concat(number % 100);
            var lastval;
            for(var a = 0; a < initialoptions.length; a++){
                if (a != initialoptions.length - 1) {
                    var end = (a+1) * initialoptions[a];
                    var start = end-99;
                    var selectedFileName = 'email_list-'+start+'-'+end+'_'+this.emailAppendFile;
                    var exists = this.checkRangeFile(selectedFileName);
                    var currentitem = {'id':a+1,'start':start,'end':end,'exists':exists};
                    this.range.push(currentitem);
                    lastval = end;
                } else {
                    var end = lastval + (initialoptions[a]);
                    var start = lastval+1;
                    var selectedFileName = 'email_list-'+start+'-'+end+'_'+this.emailAppendFile;
                    var exists = this.checkRangeFile(selectedFileName);
                    var currentitem = {'id':a+1,'start':start,'end':end,'exists':exists};
                    if (initialoptions[a] != 0) {
                        this.range.push(currentitem);
                    }
                }
                // this.selectInitialRange(this.range[0]);
                console.log('test current selected value: '+JSON.stringify(this.rangeSelected));
            }
            var newcols = [];
            var oldcols = [];
            let keys = Object.keys(this.passedData[0]);
            for (const [key, value] of Object.entries(this.passedData[0])) {
                var curkey = key.toLowerCase();
                if(curkey.includes("fn") || curkey.includes("first") || curkey == 'FN') {
                    newcols.push("FirstName");
                    oldcols.push(key);
                } else if(curkey.includes("ln") || curkey.includes("last") || curkey == 'LN') {
                    newcols.push("LastName");
                    oldcols.push(key);
                } else if(curkey.includes("add")) {
                    newcols.push("Address");
                    oldcols.push(key);
                } else if(curkey.includes("cit")) {
                    newcols.push("City");
                    oldcols.push(key);
                } else if(curkey.includes("sta")) {
                    newcols.push("State");
                    oldcols.push(key);
                } else if(curkey.includes("zip") || curkey.includes("post")) {
                    newcols.push("Zip");
                    oldcols.push(key);
                } else {
                    newcols.push(curkey);
                    oldcols.push(key);
                }
                
            }
                for(var j = 0; j < this.passedData.length; j++){
                    for (var key in this.passedData[j]) {
                        for (var i = 0; i < oldcols.length; i++) {
                            var oldval = oldcols[i];
                            if(key == [oldcols[i]]) {
                                this.passedData[j][newcols[i]] = this.passedData[j][oldcols[i]];
                                if(oldcols[i] != newcols[i]) {
                                    delete this.passedData[j][oldval];
                                }
                            }
                        }
                    } 
                };
                for(var j = 0; j < this.passedData.length; j++){
                    for (var key in this.passedData[j]) {
                        if(key == 'Zip') {
                            this.passedData[j]['Zip'] = this.passedData[j].Zip.toString().padStart(5, "0");
                        }
                        
                    } 
                };
                this.activeEmailAppend = this.passedData;
        },
        lookupEmailAddress() {
            axios({
                method : 'POST',
                url : 'https://secureapi.datazapp.com/Appendv2',
                data:'{"ApiKey": "PDKTMPEUKR","AppendModule": "EmailAppend","AppendType": 1,"Data": '+JSON.stringify(this.activeEmailAppend)+'}',
                headers: {"Content-Type": "application/json"},
            }).then(
                (response) => {
                    var olddata = this.conformRange(this.passedData);
                    this.activeEmailAppend = response.data.ResponseDetail.Data;
                    this.$emit('decreaseEmailCount', this.countReturnedEmails(response.data.ResponseDetail.Data));
                    var updateAppend = this.appendFinalData(olddata, this.activeEmailAppend);
                    this.processEmailData(JSON.stringify(updateAppend),this.rangeSelected.start, this.rangeSelected.end, this.emailAppendFile);
            })
                .catch(error => {
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
            });
        },
        processEmailData(updated,start,end,original) {
            let formData = new FormData();
            formData.append('maindata', updated);
            formData.append('start', start);
            formData.append('end', end);
            formData.append('original',original);
            axios({
                method : 'POST',
                url : '/process_email_list',
                data: formData
            }).then(
                (response) => {
                    //console.log('Email file generation (path): '+response.data);
                    // var downloadbtn = '<a href="/user_dataset?dataset='+response.data+'&amp;format=raw&amp;objid=null" class="btn btn-lg btn-info mt-4" download="'+response.data+'" target="_blank">Download Appended List</a>';
                    // this.$refs["download_append_list"].innerHTML = downloadbtn;
                    this.$emit('customChange', {shell: 'EmailAppend', dataset: ''});
                    this.$emit('updateUserSessionData');
            })
                .catch(error => {
                    this.errorMessage = error.message;
                    console.error("There was an error!", error);
            });
        }
    },
    mounted() {        
        this.transformData();
    }
}
</script>